import { Browser } from '@capacitor/browser'
import { Capacitor } from '@capacitor/core'

const officialHosts = new Set([
  'gg.go.kr',
  'www.gg.go.kr',
  'web1.gg.go.kr',
  'gtrans.or.kr',
  'www.gtrans.or.kr',
  'gbuspb.kr',
  'www.gbuspb.kr',
])

export function isAllowedOfficialUrl(value: string) {
  try {
    const url = new URL(value)
    return url.protocol === 'https:' && officialHosts.has(url.hostname)
  } catch {
    return false
  }
}

export async function openOfficialUrl(value: string) {
  if (!isAllowedOfficialUrl(value)) return false
  if (Capacitor.isNativePlatform()) {
    await Browser.open({ url: value })
  } else {
    window.open(value, '_blank', 'noopener,noreferrer')
  }
  return true
}
